import script from "./Welcome.vue?vue&type=script&setup=true&lang=ts"
export * from "./Welcome.vue?vue&type=script&setup=true&lang=ts"

import "./Welcome.vue?vue&type=style&index=0&id=73fd4139&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73fd4139"]])

export default __exports__